import _ from 'lodash';

export function decodeHTML(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}
export function validURL(str) {
  const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
    + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
    + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
    + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!pattern.test(str);
}
export function prepareDataForElements(actualStep) {
  let data = Object.assign({}, actualStep);

  switch (actualStep.type) {
    case 'custom':
      data.narrativeType = data.narrative_type;
      break;
    case 'creation_form':
      data.type = 'form_element';
      data.text = data.title;
      data.narrativeType = data.narrative_type;
      data.elementType = data.element_type;
      break;
    case 'faces':
      data = {
        type: 'users_match_element',
        text: actualStep.title,
        narrativeType: actualStep.narrative_type,
        elements: actualStep.users,
        select: actualStep.more_info.select,
        sort: actualStep.more_info.sort,
        actionSelect: actualStep.more_info.action,
        sortField: actualStep.more_info.action,
        answers: _.map(actualStep.answers, answer => parseInt(answer, 10)),
        more_info: actualStep.more_info,
      };
      break;
    case 'select':
      data = {
        type: 'list',
        text: actualStep.title,
        narrativeType: actualStep.narrative_type,
        elementType: actualStep.element_type,
        context: actualStep.context,
        elements: actualStep.elements,
        maxOptions: actualStep.more_info.max_answers,
        canCreate: actualStep.more_info.can_create,
        answers: actualStep.answers,
        more_info: actualStep.more_info,
      };
      break;
    case 'top_elements':
      data.text = data.title;
      data.elementId = `${data.narrative_type}-${data.element_type}`;
      break;
    case 'input':
      data = {
        type: 'input',
        text: actualStep.title,
        narrativeType: actualStep.narrative_type,
        elementType: actualStep.element_type,
        context: actualStep.context,
        answers: actualStep.answers,
        more_info: actualStep.more_info,
      };
      break;
    default:
      break;
  }

  return data;
}



// WEBPACK FOOTER //
// ./src/utils/data.js